// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2NPYu","header":"PatientQuestionnaire_header__2YyN2","info":"PatientQuestionnaire_info__1Yww5"};